import { WebApiService } from 'app/services/webapi.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { IEvent, IStatus } from '../components/System/event.interface';

@Injectable()
export class SystemService {
    private headers = new Headers({ 'Content-Type': 'application/json' });
    private userUrl = 'api/System';  // URL to web api

    constructor(private http: Http, private webApi: WebApiService) { }

    getEventLog(): Promise<IEvent[]> {
        return this.webApi.get(this.userUrl + '/GetEventLog');
    }

    stopService(): Promise <IStatus> {
        return this.webApi.get(this.userUrl + '/StopService');
    }

    startService(): Promise <IStatus> {
        return this.webApi.get(this.userUrl + '/StartService');
    }

    getServiceStatus(): Promise <IStatus> {
        return this.webApi.get(this.userUrl + '/ServiceStatus');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/system.service.ts